import React from "react";
import { getValue } from "@utils/lodash";

function SearchSubheaderSvgComponent(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"  height={
      getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
    }
    width={
      getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
    }
    viewBox="0 0 24 24">
      <defs>
        <clipPath id="clip-path-search">
          <rect id="Rectangle_18197" data-name="Rectangle 18197" width="24" height="24" transform="translate(-14711 -8345)" fill="#fff"/>
        </clipPath>
      </defs>
      <g id="Mask_Group_305" data-name="Mask Group 305" transform="translate(14711 8345)" clip-path="url(#clip-path-search)">
        <path id="search_FILL0_wght300_GRAD0_opsz24_1_" data-name="search_FILL0_wght300_GRAD0_opsz24 (1)" d="M21.17-11.289l-6.39-6.39a5.816,5.816,0,0,1-1.755.986,6.029,6.029,0,0,1-2.052.356,6.006,6.006,0,0,1-4.415-1.806,6,6,0,0,1-1.807-4.414,6.009,6.009,0,0,1,1.806-4.415,6,6,0,0,1,4.414-1.808,6.008,6.008,0,0,1,4.415,1.807,6,6,0,0,1,1.808,4.415,5.967,5.967,0,0,1-.366,2.082,5.819,5.819,0,0,1-.976,1.726l6.39,6.39Zm-10.2-6.573A4.532,4.532,0,0,0,14.3-19.227a4.532,4.532,0,0,0,1.365-3.331A4.532,4.532,0,0,0,14.3-25.888a4.532,4.532,0,0,0-3.331-1.365,4.532,4.532,0,0,0-3.331,1.365,4.532,4.532,0,0,0-1.365,3.331,4.532,4.532,0,0,0,1.365,3.331,4.532,4.532,0,0,0,3.331,1.365Z" transform="translate(-14712.497 -8312.967)" fill={
          getValue(props, `color`, "")
            ? getValue(props, `color`, "")
            : "#5f6368"
        } />
      </g>
    </svg>
  );
}

export default SearchSubheaderSvgComponent;
